import { render, staticRenderFns } from "./CartDiamondCustom.vue?vue&type=template&id=822cbb92&scoped=true"
import script from "./CartDiamondCustom.vue?vue&type=script&lang=js"
export * from "./CartDiamondCustom.vue?vue&type=script&lang=js"
import style0 from "./CartDiamondCustom.vue?vue&type=style&index=0&id=822cbb92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822cbb92",
  null
  
)

export default component.exports